import { ReactNode } from 'react'

export enum PartnerConfigKey {
  SUPPORTED_CURRENCIES = 'supported_currencies',
  FEATURED = 'featured',
  GAMIFICATION_DISPLAY = 'gamification_display',
  PREFERRED_COUNTRIES = 'preferred_countries',
  REGIONS = 'regions'
}

export type PartnerRegionsConfigValue = {
  [regionId: string]: { id: string; name: string; countryCodes: string[] }
}

export type PartnerConfigData = {
  partnerId: string
  key: string
  value: string[] | PartnerRegionsConfigValue
  createdAt: string
}

export type PartnerConfigContextType = {
  configData: PartnerConfigData | null
  isConfigError: { code: string; message: string; reasons: string[]; title: string } | null
}

export type PartnerConfigProviderProps = {
  children: ReactNode
  partnerConfigKey: PartnerConfigKey
}
